var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"d5X7eonf68T7vFgrTPLP5"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/transportation-build/8c06207e05d40d7dfff757a52f3d4bb2eb632ddd";

import * as Sentry from '@sentry/nextjs';

const env = process.env.NEXT_PUBLIC_TARGET_ENV || 'development';
const isProduction = env === 'production';
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

if (isProduction) {
  Sentry.init({
    dsn:
      SENTRY_DSN ||
      'https://584d691c5e14c03a16d2067065ac2c91@o249654.ingest.us.sentry.io/4508845056917504',
    environment: env,
    tracesSampleRate: 1.0,
  });
}
